import type { ReactElement } from 'react';
import React from 'react';
import { Badge } from 'reactstrap';
import { useGroups } from 'services/assist-api/entities/group/groups';
import { useAuthCustomer } from 'services/providers/auth.hooks';

export function ClassTile({ children }: React.PropsWithChildren): ReactElement {
  return (
    <Badge className="me-1" color="primary">
      {children}
    </Badge>
  );
}

export default function ClassesDisplay({ classIds }: { classIds: number[] }): ReactElement {
  const organisation = useAuthCustomer();
  const groups = useGroups({ filters: { customer: organisation?.id } }).data?.json;
  return (
    <>
      {classIds.map((id) => (
        <ClassTile key={id}>{groups?.find((c) => c.id === id)?.name}</ClassTile>
      ))}
    </>
  );
}
